import * as React from 'react';

import * as main from '../../../styles/mainOld.module.scss';
import * as courseModule from './courseModule.module.scss';

export const CourseModuleFour = ({ badgeText, resultText }) => {
  return (
    <section
      className={`${courseModule.courseModule} ${courseModule.courseModuleGrey} ${courseModule.courseModuleFour}`}
    >
      <div className="container">
        <p className={courseModule.courseModule__important}>{badgeText} 4</p>
        <h3 className={courseModule.courseModule__subtitle}>
          Базовая информация по&nbsp;основным школьным дисциплинам
        </h3>
        <p className={courseModule.courseModule__description}>
          Все освоенные на&nbsp;курсе навыки ребенок отрабатывает на&nbsp;базовом материале школьных предметов, что
          позволяет одновременно повторить и&nbsp;загрузить в&nbsp;долгосрочную память ранее пройденный материал
          и&nbsp;создать фундамент для понимания еще не&nbsp;пройденного, за счет предварительной загрузки формул
          и&nbsp;определений в&nbsp;память до&nbsp;разбора соответствующего предмета в&nbsp;школе.
        </p>
        <div className={`row ${courseModule.courseModule__row}`}>
          <div className="col-12 col-lg-9">
            <ul className={courseModule.courseModule__list}>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <h4 className={courseModule.courseModule__heading}>Английский язык</h4>
                <p className={courseModule.courseModule__text}>
                  Первые 150&nbsp;слов. Неправильные глаголы. 16&nbsp;времен. Грамматика. Лексика для&nbsp;ОГЭ
                  и&nbsp;ЕГЭ.
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <h4 className={courseModule.courseModule__heading}>Русский язык</h4>
                <p className={courseModule.courseModule__text}>
                  206&nbsp;ударений для&nbsp;ЕГЭ, архаизмы. Остальное ребенок освоит сам.
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <h4 className={courseModule.courseModule__heading}>Математика</h4>
                <p className={courseModule.courseModule__text}>
                  9&nbsp;величин, 86&nbsp;формул и&nbsp;10&nbsp;признаков делимости.
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <h4 className={courseModule.courseModule__heading}>Физика</h4>
                <p className={courseModule.courseModule__text}>
                  61&nbsp;формула и&nbsp;27&nbsp;величин для этих формул.
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <h4 className={courseModule.courseModule__heading}>Геометрия</h4>
                <p className={courseModule.courseModule__text}>
                  76&nbsp;определений, 90&nbsp;теорем и&nbsp;13&nbsp;аксиом.
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <h4 className={courseModule.courseModule__heading}>Химия</h4>
                <p className={courseModule.courseModule__text}>
                  Таблица Менделеева. Формулы. Аминокислоты и&nbsp;их&nbsp;обозначение. Номенклатура алканов.
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <h4 className={courseModule.courseModule__heading}>География</h4>
                <p className={courseModule.courseModule__text}>
                  Страны и&nbsp;столицы. Субъекты, крупные города и&nbsp;округа РФ&nbsp;и&nbsp;Европы. Материки.
                  Созвездия. Типы гор. Глубины и&nbsp;площади морей и&nbsp;озер.
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <h4 className={courseModule.courseModule__heading}>Литература</h4>
                <p className={courseModule.courseModule__text}>Даты жизни писателей.</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <h4 className={courseModule.courseModule__heading}>ОБЖ</h4>
                <p className={courseModule.courseModule__text}>Классификация техногенных чрезвычайных ситуаций.</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <h4 className={courseModule.courseModule__heading}>История</h4>
                <p className={courseModule.courseModule__text}>Романовы и&nbsp;Рюрики. 340&nbsp;дат истории России.</p>
              </li>
              <li className={courseModule.courseModule__item}>
                <h4 className={courseModule.courseModule__heading}>Биология</h4>
                <p className={courseModule.courseModule__text}>
                  Анатомия, зоология, ботаника. Способ выучивания схем.{' '}
                </p>
              </li>
            </ul>
          </div>
          <div className={`col-12 col-lg-3 ${courseModule.courseModule__sideData}`}>
            <div className={main.sideData}>
              <p className={main.sideData__smallText}>
                <b>
                  Дети начинают понимать учителей на&nbsp;уроке в&nbsp;реальном времени, а&nbsp;не&nbsp;через год при
                  прохождении темы с&nbsp;репетитором
                </b>
              </p>
            </div>
            <div className={main.sideData}>
              <p className={main.sideData__smallText}>
                <b>Школьные предметы щелкаются как орешки</b>
              </p>
            </div>
          </div>
        </div>

        <div className={courseModule.courseModule__result}>
          <h3 className={courseModule.courseModule__resultTitle}>{resultText}</h3>
          <div className="row">
            <div className={`col-12 col-md-6 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>
                Прохождение базы школьных предметов позволяет быстро выучить и&nbsp;сдать вперед все непрофильные
                предметы, чтобы высвободить время для по&nbsp;настоящему важных и&nbsp;интересных задач
              </p>
            </div>
            <div className={`col-12 col-md-6 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>
                Учеба перестает быть трудностью, и&nbsp;аккуратно занимает положенное место в&nbsp;расписании,
                не&nbsp;разрастаясь в&nbsp;свободное время ребенка и&nbsp;родителей
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
